// 参数模板集中来源，供计算页与测试复用

// 常用参数模板（按保护类型绑定）
export const PARAM_TEMPLATES = {
  overcurrent: {
    dist_line: {
      systemVoltage: 10.5,
      ratedCurrent: 800,
      ctRatio: 600,
      ptRatio: 100,
      faultCurrent: 6000,
      protectionType: 'overcurrent',
      curveType: 'Normal Inverse',
      timeMultiplier: 0.5
    },
    plant_feeder: {
      systemVoltage: 35,
      ratedCurrent: 1200,
      ctRatio: 800,
      ptRatio: 100,
      faultCurrent: 12000,
      protectionType: 'overcurrent',
      curveType: 'Very Inverse',
      timeMultiplier: 0.4
    },
    // 厂家/场景扩展（保持曲线族兼容 IEC 映射，元数据用于上下文展示与后续校验）
    abb_dist_ni: {
      vendor: 'ABB',
      scene: '配电线路',
      systemVoltage: 10.5,
      ratedCurrent: 800,
      ctRatio: 600,
      ptRatio: 100,
      faultCurrent: 5800,
      protectionType: 'overcurrent',
      curveType: 'Normal Inverse',
      timeMultiplier: 0.45
    },
    sel_plant_vi: {
      vendor: 'SEL',
      scene: '电厂馈线',
      systemVoltage: 35,
      ratedCurrent: 1200,
      ctRatio: 800,
      ptRatio: 100,
      faultCurrent: 12500,
      protectionType: 'overcurrent',
      curveType: 'Very Inverse',
      timeMultiplier: 0.42
    }
  },
  directional: {
    feeder_dir: {
      systemVoltage: 35,
      ratedCurrent: 1000,
      ctRatio: 600,
      ptRatio: 100,
      faultCurrent: 9000,
      protectionType: 'directional',
      polarizingAngle: 30,
      curveType: 'Normal Inverse',
      timeMultiplier: 0.5
    },
    ring_network_dir: {
      systemVoltage: 10.5,
      ratedCurrent: 800,
      ctRatio: 600,
      ptRatio: 100,
      faultCurrent: 6000,
      protectionType: 'directional',
      polarizingAngle: 45,
      curveType: 'Very Inverse',
      timeMultiplier: 0.4
    },
    schneider_dir_vi: {
      vendor: 'Schneider',
      scene: '环网/方向保护',
      systemVoltage: 10.5,
      ratedCurrent: 800,
      ctRatio: 600,
      ptRatio: 100,
      faultCurrent: 6200,
      protectionType: 'directional',
      polarizingAngle: 45,
      curveType: 'Very Inverse',
      timeMultiplier: 0.38
    }
  },
  zero_sequence: {
    feeder_zs: {
      systemVoltage: 10.5,
      ratedCurrent: 800,
      ctRatio: 600,
      ptRatio: 100,
      faultCurrent: 3000,
      protectionType: 'zero_sequence',
      k0: 0.3,
      curveType: 'Very Inverse',
      timeMultiplier: 0.4
    },
    solid_ground_zs: {
      systemVoltage: 35,
      ratedCurrent: 1200,
      ctRatio: 800,
      ptRatio: 100,
      faultCurrent: 8000,
      protectionType: 'zero_sequence',
      k0: 0.4,
      curveType: 'Normal Inverse',
      timeMultiplier: 0.5
    },
    schneider_zs_vi: {
      vendor: 'Schneider',
      scene: '实效接地/零序',
      systemVoltage: 35,
      ratedCurrent: 1200,
      ctRatio: 800,
      ptRatio: 100,
      faultCurrent: 7800,
      protectionType: 'zero_sequence',
      k0: 0.35,
      curveType: 'Very Inverse',
      timeMultiplier: 0.42
    }
  },
  distance: {
    line_distance: {
      systemVoltage: 110,
      ratedCurrent: 800,
      ctRatio: 600,
      ptRatio: 100,
      faultCurrent: 12000,
      protectionType: 'distance'
    },
    hv_line_distance: {
      systemVoltage: 220,
      ratedCurrent: 1500,
      ctRatio: 1000,
      ptRatio: 1000,
      faultCurrent: 20000,
      protectionType: 'distance'
    }
  },
  differential: {
    transformer_diff: {
      systemVoltage: 35,
      ratedCurrent: 1500,
      ctRatio: 800,
      ptRatio: 100,
      faultCurrent: 10000,
      protectionType: 'differential'
    },
    transformer_diff_heavy: {
      systemVoltage: 110,
      ratedCurrent: 2000,
      ctRatio: 1000,
      ptRatio: 100,
      faultCurrent: 15000,
      protectionType: 'differential'
    }
  },
  longitudinal: {
    line_longitudinal: {
      systemVoltage: 110,
      ratedCurrent: 1200,
      ctRatio: 800,
      ptRatio: 100,
      faultCurrent: 10000,
      protectionType: 'longitudinal'
    },
    hv_line_longitudinal: {
      systemVoltage: 220,
      ratedCurrent: 1500,
      ctRatio: 1000,
      ptRatio: 100,
      faultCurrent: 20000,
      protectionType: 'longitudinal'
    }
  }
};

// 模板选项标签（按类型）
export const TEMPLATE_OPTIONS = {
  overcurrent: [
    { value: 'dist_line', label: '配电线路典型' },
    { value: 'plant_feeder', label: '电厂馈线典型' },
    { value: 'abb_dist_ni', label: 'ABB·配电线路·NI' },
    { value: 'sel_plant_vi', label: 'SEL·电厂馈线·VI' }
  ],
  directional: [
    { value: 'feeder_dir', label: '方向保护馈线典型' },
    { value: 'ring_network_dir', label: '环网方向保护典型' },
    { value: 'schneider_dir_vi', label: 'Schneider·环网方向·VI' }
  ],
  zero_sequence: [
    { value: 'feeder_zs', label: '零序保护馈线典型' },
    { value: 'solid_ground_zs', label: '实效接地零序典型' },
    { value: 'schneider_zs_vi', label: 'Schneider·实效接地·VI' }
  ],
  distance: [
    { value: 'line_distance', label: '距离保护线路典型' },
    { value: 'hv_line_distance', label: '高压线路距离典型' }
  ],
  differential: [
    { value: 'transformer_diff', label: '变压器差动典型' },
    { value: 'transformer_diff_heavy', label: '重载变压器差动典型' }
  ],
  longitudinal: [
    { value: 'line_longitudinal', label: '线路纵联差动典型' },
    { value: 'hv_line_longitudinal', label: '高压线路纵联差动典型' }
  ]
};

// 每种保护类型默认模板
export const DEFAULT_TEMPLATE_FOR_TYPE = {
  overcurrent: 'dist_line',
  directional: 'feeder_dir',
  zero_sequence: 'feeder_zs',
  distance: 'line_distance',
  differential: 'transformer_diff',
  longitudinal: 'line_longitudinal'
};

// 模板边界校验（软性）：返回 { errors: [], warnings: [] }
export const validateTemplateBounds = (preset) => {
  const errors = [];
  const warnings = [];
  if (!preset || typeof preset !== 'object') {
    errors.push('模板无效');
    return { errors, warnings };
  }
  const { ratedCurrent, ctRatio, ptRatio, faultCurrent, timeMultiplier, protectionType } = preset;
  // CT/PT 变比范围
  if (!(isFinite(ctRatio) && ctRatio >= 1 && ctRatio <= 20000)) {
    errors.push('CT 变比越界或无效');
  }
  if ((protectionType === 'distance' || protectionType === 'directional') && !(isFinite(ptRatio) && ptRatio >= 1 && ptRatio <= 10000)) {
    errors.push('PT 变比越界或无效');
  }
  // TMS 合理范围（IEC/IEEE 通用建议）
  if (!(isFinite(timeMultiplier) && timeMultiplier >= 0.05 && timeMultiplier <= 1.5)) {
    warnings.push('时间倍数 TMS 建议处于 0.05~1.5');
  }
  // 故障电流应高于额定电流的若干倍（软性提醒）
  if (isFinite(ratedCurrent) && isFinite(faultCurrent) && faultCurrent < ratedCurrent * 1.2) {
    warnings.push('故障电流略低，可能导致倍数接近 1');
  }
  return { errors, warnings };
};